// 테스트용 인증 함수
export async function testLogin(email: string, password: string) {
  try {
    
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ email, password }),
      // 자체 서명 인증서 문제 해결을 위한 옵션
      mode: 'cors',
      credentials: 'include',
    });

    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ Test login error:', error);
    throw error;
  }
}

// 브라우저 콘솔에서 테스트하기 위한 글로벌 함수
(window as any).testLogin = testLogin;